import PivotTableSettingsController from './pivot-table-settings-controller';

const PivotTableSettingsComponent: angular.IComponentOptions = {
  controller: PivotTableSettingsController,
  controllerAs: 'ctrl',
  bindings: {
    view: '<',
    data: '<',
    token: '<',
    containerHeight: '<',
    onSettingsUpdate: '&?',
  },
  template: `
    <div
      class="pivot-table-settings"
      ng-if="!ctrl.dataExceedsLimit()"
      style="height: {{ctrl.containerHeight}}px">

      <div class="chart-accordion">

        <!-- Tab Navigation Begins -->
        <div class="chart-nav">
          <ul class="nav nav-tabs nav-tabs-bottom nav-tabs-inline">
          <li ng-class="{active:ctrl.state.accordion.chart}"><a ng-click="ctrl.selectTab('chart')">Data</a></li><!--
          --><li ng-class="{active:ctrl.state.accordion.format}"><a ng-click="ctrl.selectTab('format')">Format</a></li>
          </ul>
        </div>
        <!-- @Tab Navigation Ends-->

        <!-- Data Tab Begins -->
        <div class="chart-tab-content no-overflow" ng-show="ctrl.state.accordion.chart">

          <!-- Pivot Config Begins -->
          <pivot-config
            intro-html="ctrl.pivotConfigIntro"
            hide-intro="!ctrl.isReportMode()"
            columns="ctrl.data.columns"
            height="ctrl.getPivotConfigHeight()"
            quadrant-map="ctrl.pivotTableViewOptions()"
            on-item-context-triggered="ctrl.handleItemContextTrigger($quadrant, $itemId)"
            on-filter-change="ctrl.handleFilterChange($field, $old)"
            on-value-change="ctrl.handleValueChange($field, $old)"
            on-column-change="ctrl.handleColumnChange($field, $old)"
            on-row-change="ctrl.handleRowChange($field, $old)" ></pivot-config>
          <!-- @Pivot Config Ends-->

        </div>
        <!-- @Data Tab Ends -->

        <!-- Format Tab Begins -->
        <div class="chart-tab-content" ng-show="ctrl.state.accordion.format">

          <!-- Format Settings Begin -->
          <format-settings
            format-options="ctrl.getFormatSettings()"
            enabled-formats="['automatic', 'number', 'percentage', 'financial', 'currency']"
            on-change="ctrl.updateFormatSettings($formatOptions)">
          </format-settings>
          <!-- @Format Settings End -->

        </div>
        <!-- @Format Tab Ends-->

        <settings-context-panel
          context="ctrl.state.contextPanel.quadrant"
          panel-height="ctrl.containerHeight"
          title="{{ctrl.state.contextPanel.quadrant}}"
          subtitle="{{ctrl.state.contextPanel.field}}"
          list-type="ctrl.state.contextPanel.type"
          list-available="ctrl.state.contextPanel.available"
          list-selected="ctrl.state.contextPanel.selected"
          enabled="ctrl.state.contextPanel.enabled"
          filter-enabled="ctrl.state.contextPanel.filterEnabled"
          on-dismiss="ctrl.handleContextDismiss()"
          on-update="ctrl.handleContextUpdate($selected, $context)">
        </settings-context-panel>

      </div>
    `,
};

export { PivotTableSettingsComponent };
